export default __webpack_public_path__ + "static/media/Programming2.9f1a7d0e.png";